import { Endpoints, generateAxios } from '@matap/shared';
import { generateMutation } from './create-hooks';

export const useSubmitSurvey = generateMutation(Endpoints.surveys.user.submit, (endpoint) => ({
  mutationFn: (payload) => generateAxios(endpoint, payload).then((r) => r.data),
}));

export const useCancelSurvey = generateMutation(Endpoints.surveys.user.cancel, (endpoint) => ({
  mutationFn: (payload) => generateAxios(endpoint, payload).then((r) => r.data),
}));
